export default __webpack_public_path__ + "static/media/helmet5.a72da958.svg";